import { Checkbox, FormControlLabel, FormGroup, Stack, Typography } from '@mui/material'
import { t } from 'i18next'
import { useState } from 'react'

const StatusFilter = ({ filters = {}, onChange }) => {
  const { showOffline } = filters

  const [online, setOnline] = useState(null)
  const [offline, setOffline] = useState(null)

  const handleChangeOffline = (_, value) => {
    setOffline(value)
    !value && !online
      ? onChange({ showOffline: null })
      : onChange({ showOffline: value })
  }

  const handleChangeOnline = (_, value) => {
    setOnline(value)
    !value && !offline
      ? onChange({ showOffline: null })
      : onChange({ showOffline: false })
  }

  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        mt={3}
        mb={3}
      >
        <Typography
          id="device-status-label"
          align="left"
          sx={{ fontWeight: 'bold' }}
        >
          {t('filters.devices.other.status.label')}
        </Typography>
        <FormGroup
          role="group"
          row
        >
          <FormControlLabel
            id="device-status-online-label"
            value="online"
            control={
              <Checkbox
                onChange={handleChangeOnline}
                aria-labelledby="device-status-label "
                checked={showOffline !== null && !showOffline}
                disabled={showOffline !== null && showOffline}
              />
            }
            label={t('filters.devices.other.status.valueTrue')}
            sx={{ width: '100px' }}
          />
          <FormControlLabel
            id="device-status-offline-label"
            value="offline"
            control={
              <Checkbox
                onChange={handleChangeOffline}
                aria-labelledby="device-status-label "
                checked={showOffline !== null && showOffline}
                disabled={showOffline !== null && !showOffline}
              />
            }
            label={t('filters.devices.other.status.valueFalse')}
            sx={{ width: '100px' }}
          />
        </FormGroup>
      </Stack>
    </>
  )
}

export default StatusFilter
